import { FullCourse } from 'server/types';
import { AsyncForm, FormSubSection, InputLabel, Subtext } from '@components/async-form';
import { rpx } from 'client/lib/rpx-client';
import { BtnPrimary } from '@components/buttons';
import { showToast } from '@components/toaster';
import { HeadingSecondary } from '@course/components/headings';
import { ACES_PROGRAMS, isAcesProgram } from 'shared/aces-program';

type Props = {
  course: FullCourse;
  onUpdate: (updates: Pick<FullCourse, 'acesProgram'>) => void;
};

export function AcesSettings({ course, onUpdate }: Props) {
  async function submit(formData: { program?: string }) {
    const program = isAcesProgram(formData.program) ? formData.program : null;
    const result = await rpx.courseSettings.setAcesProgram({ courseId: course.id, program });
    showToast({
      title: 'Saved',
      message: result.acesProgram ? `Shown in ACES as ${result.acesProgram}` : 'Not shown in ACES',
      type: 'ok',
    });
    onUpdate({ acesProgram: result.acesProgram });
  }

  return (
    <AsyncForm class="flex flex-col gap-6" onSubmit={submit}>
      <HeadingSecondary>ACES</HeadingSecondary>
      <FormSubSection>
        <InputLabel>Show in ACES</InputLabel>
        <Subtext>
          When on, ACES coaches see this course's progress, standups and tracker on their clients'
          records.
        </Subtext>
        <select
          class="inline-ruz-input"
          name="program"
          aria-label="Show in ACES"
          defaultValue={course.acesProgram ?? ''}
        >
          <option value="">Off</option>
          {ACES_PROGRAMS.map((program) => (
            <option key={program} value={program}>
              {program}
            </option>
          ))}
        </select>
      </FormSubSection>
      <footer>
        <BtnPrimary>Save</BtnPrimary>
      </footer>
    </AsyncForm>
  );
}
